import { IError } from '../../../../common/error/IError';
import { handleUnauthorizedError } from '../../../common/rest/handleUnauthorizedError';

export class CoreRestErrorHandler {
  handle = (errorResponse: any) => {
    handleUnauthorizedError(errorResponse);

    const json = errorResponse?.json;

    if (json && typeof json === 'object') {
      if (json.status || json.errorName) {
        throw json;
      }

      if (json.webCode) {
        json.webCode = String(json.webCode);
        throw json;
      }
    }

    const status =
      errorResponse?.status ??
      errorResponse?.response?.status ??
      '500';

    const unknownError: IError = {
      data: {},
      systemCode: 'unknown',
      webCode: String(status),
      message: 'Ошибка сервера',
    };

    throw unknownError;
  };
}
